// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nAQBg","largestCol":"styles_largestCol__3lR5w","smallestCol":"styles_smallestCol__RTMlA"};